<script>
import DaylogService from "@/services/DaylogService";
import VTripleTime from "@/components/Task/Widgets/VTripleTime";
import LeClock from "../Clockin/LeClock";
import HalfDashCard from "@/components/Cards/HalfDashCard";
import Cloner from "@/libraries/Cloner";
import Messages from "@/mixins/Messages";
import dayjs from "dayjs";
import { EventBus } from "@/libraries/EventBus";

export default {
    props: {
        date: {}
    },
    mixins: [Messages],
    components: { VTripleTime, LeClock, HalfDashCard },
    data() {
        return {
            editing: false,
            saving: false,
            loading: true,
            enableReg: true,
            enableSick: true,
            enableOthers: true,
            enableHoli: true,
            pickDate: "",
            day: {
                id: null,
                entry_date: null,
                time_start: null,
                time_stop: null,
                total_time: null,
                pause_time: null,
                work_time: null,
                goal_time: null,
                absence_sick_time: null,
                absence_others: null,
                absence_holiday_time: null,
                off_in_lieu: null,
                diff_time: null,
                status: null
            },
            absence: {},
            errors: {}
        };
    },
    computed: {
        time_start() {
            return this.day.time_start;
        },
        time_stop() {
            return this.day.time_stop;
        },
        pause_time() {
            return this.day.pause_time;
        },
        total_absence() {
            return (
                parseInt(this.day.absence_sick_time) +
                parseInt(this.day.absence_others) +
                parseInt(this.day.absence_holiday_time)
            );
        },
        total_time() {
            const sum =
                (this.day.work_time === null
                    ? 0
                    : parseInt(this.day.work_time)) + this.total_absence;
            return sum;
        },
        remaining_time() {
            if (this.day.work_time > 0 || this.total_absence > 0) {
                if (this.day.goal_time - this.total_time < 0) {
                    return 0;
                } else {
                    return this.day.goal_time - this.total_time;
                }
            } else {
                return 0;
            }
        },
        balance() {
            return this.total_time - this.day.goal_time;
        },
        canSave() {
            if (this.total_absence > this.day.goal_time) {
                return false;
            }

            return true;
        }
    },
    watch: {
        time_start: function(v) {
            this.timerWatch(v);
        },
        time_stop: function(v) {
            this.timerWatch(v);
        },
        pause_time: function(v) {
            this.timerWatch(v);
        }
    },
    async created() {
        if (this.date === null || typeof this.date === "undefined") {
            this.pickDate = dayjs().format("YYYY-MM-DD");
        } else {
            this.pickDate = this.date;
        }
        await this.fetchData();
        this.loading = false;
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await DaylogService.GET_currentDay(
                    this.pickDate
                );
                this.day = Cloner.pickClone(data.data, [
                    "id",
                    "entry_date",
                    "time_start",
                    "time_stop",
                    "total_time",
                    "pause_time",
                    "work_time",
                    "goal_time",
                    "absence_sick_time",
                    "absence_others",
                    "absence_holiday_time",
                    "off_in_lieu",
                    "diff_time",
                    "status"
                ]);
            } catch (e) {
                console.log("fd, e", e);
            }
        },
        async saveForm() {
            try {
                if (this.day.status === 0) {
                    const { data } = await DaylogService.POST(this.day);
                } else {
                    const { data } = await DaylogService.PUT(this.day);
                }
                this.errors = {};
                this.$msgSuccess(
                    this.$t("daylogs.notify_registration_data_saved")
                );
                EventBus.$emit("daylogs-change");
                this.$emit("close");
            } catch (e) {
                this.errors = e.response.data.errors;
                console.log("sf, e", e);
                this.$msgError(this.$t("daylogs.notify_error_sth_went_wrong"));
            }
        },
        timerWatch(nV) {
            if (
                typeof this.day.time_start === "string" &&
                typeof this.day.time_stop === "string"
            ) {
                const from = this.day.time_start.split(":");
                const to = this.day.time_stop.split(":");

                let from_hr = parseInt(from[0]) * 60 + parseInt(from[1]);
                let to_hr = parseInt(to[0]) * 60 + parseInt(to[1]);

                let day_diff = (to_hr - from_hr) * 60;
                const pause = parseInt(this.day.pause_time);

                // Adjust the pause NPI
                if (pause == 0) {
                    if (day_diff > 21600 && day_diff <= 32400) {
                        this.day.pause_time = 30 * 60;
                    } else if (day_diff > 32400) {
                        this.day.pause_time = 45 * 60;
                    }
                } else {
                    if (
                        day_diff > 21600 &&
                        day_diff <= 32400 &&
                        pause < 30 * 60
                    ) {
                        this.day.pause_time = 30 * 60;
                    } else if (day_diff > 32400 && pause < 45 * 60) {
                        this.day.pause_time = 45 * 60;
                    }
                }

                let day_p_diff = (to_hr - from_hr) * 60 - pause;

                if (day_p_diff < 0) {
                    day_p_diff = 0;
                }
                console.log(day_p_diff, day_diff);

                this.day.total_time = day_diff;
                this.day.work_time = day_p_diff;
            } else if (
                this.day.time_start === null &&
                this.day.time_stop === null
            ) {
                this.day.work_time = 0;
            }
        },
        /**
         * Enable time registration (and reset absences)
         */
        enableDayReg() {
            this.enableReg = true;
            this.day.absence_holiday_time = 0;
            this.day.absence_others = 0;
            this.day.absence_sick_time = 0;
            this.enableSick = true;
            this.enableOthers = true;
            this.enableHoli = true;
        },
        /**
         * Disable time reg + reset values
         */
        disableDayReg() {
            this.enableReg = false;
            this.day.time_start = null;
            this.day.time_stop = null;
            this.day.pause_time = 0;
        },
        /**
         * Turn the day into a whole day
         */
        markWholeDay(type) {
            this.disableDayReg();
            if (type === "sick") {
                this.day.absence_holiday_time = 0;
                this.day.absence_others = 0;
                this.day.absence_sick_time = this.day.goal_time;
                this.enableSick = true;
                this.enableOthers = false;
                this.enableHoli = false;
            } else if (type === "other") {
                this.day.absence_holiday_time = 0;
                this.day.absence_others = this.day.goal_time;
                this.day.absence_sick_time = 0;
                this.enableSick = false;
                this.enableOthers = true;
                this.enableHoli = false;
            } else if (type === "holi") {
                this.day.absence_holiday_time = this.day.goal_time;
                this.day.absence_others = 0;
                this.day.absence_sick_time = 0;
                this.enableSick = false;
                this.enableOthers = false;
                this.enableHoli = true;
            }
        },
        /**
         * Use remaining time (from goal if available) for filling out this category
         * Categories: sick, other, holi
         * @param type
         */
        markRemDay(type) {
            // this.day.goal_time;

            if (type === "sick") {
                // Sickness
                this.day.absence_sick_time = this.remaining_time;
            } else if (type === "other") {
                // Other
                this.day.absence_others = this.remaining_time;
            } else if (type === "holi") {
                // Absence / holidays
                this.day.absence_holiday_time = this.remaining_time;
            }
        },
        /**
         * Reset the counter
         * Categories: sick, other, holi
         * @param type
         */
        resetEntry(type) {
            if (type === "sick") {
                // Sickness
                this.day.absence_sick_time = 0;
            } else if (type === "other") {
                // Other
                this.day.absence_others = 0;
            } else if (type === "holi") {
                // Absence / holidays
                this.day.absence_holiday_time = 0;
            }
        },
        navigateOverview() {
            this.$emit("close");
            this.$router.push({ name: "DaylogsMyIndex" });
        },
        async deleteEntry() {
            this.$swal({
                icon: "warning",
                text: this.$t("daylogs.swal_delete_entry"),
                showConfirmButton: true,
                showCancelButton: true
            }).then(async confirmed => {
                if (confirmed.isConfirmed) {
                    try {
                        await DaylogService.DELETE(this.day.id);
                        EventBus.$emit("daylogs-change");
                        this.$emit("close");
                    } catch (e) {
                        console.log("deleteEntry: ", e);
                    }
                }
            });
        }
    }
};
</script>

<template>
    <modal
        :show="true"
        :loading="loading"
        @close="$emit('close')"
        class="budget-modal daylog-form"
        size="full"
    >
        <template slot="header">
            <span :data-daylog-id="day.id"
                >{{
                    $t("daylogs.date_DATE", {
                        DATE: $d(new Date(day.entry_date), "short")
                    })
                }}
            </span>
        </template>

        <template slot="default">
            <v-loader v-if="loading" :loading="loading" />
            <template v-else>
                <div class="row" v-if="true">
                    <div class="col">
                        <HalfDashCard
                            :title="$t('daylogs.statbox_daily_goal')"
                            disable-hover
                            icon="far fa-bullseye-arrow"
                            >{{ day.goal_time | toTime }}</HalfDashCard
                        >
                    </div>
                    <div class="col">
                        <HalfDashCard
                            :title="$t('daylogs.statbox_work_time')"
                            disable-hover
                            icon="far fa-cog fa-spin"
                            >{{ day.work_time | toTime }}</HalfDashCard
                        >
                    </div>

                    <div class="col">
                        <HalfDashCard
                            :title="$t('daylogs.statbox_total_absence')"
                            disable-hover
                            icon="far fa-user-slash"
                            >{{ total_absence | toTime }}</HalfDashCard
                        >
                    </div>

                    <div class="col">
                        <HalfDashCard
                            :title="$t('daylogs.statbox_total_time')"
                            disable-hover
                            icon="far fa-sigma"
                            >{{ total_time | toTime }}</HalfDashCard
                        >
                    </div>

                    <div class="col">
                        <HalfDashCard
                            :title="$t('daylogs.statbox_balance')"
                            disable-hover
                            icon="far fa-balance-scale"
                            ><span :class="{ 'text-danger': balance < 0 }">{{
                                balance | rTime
                            }}</span></HalfDashCard
                        >{{ day.goal_time | toTime }}
                    </div>
                </div>
                <hr class="mt-0 mb-1" />

                <div class="row">
                    <template v-if="enableReg">
                        <div class="col-12 mt-3 mb-4">
                            <h3 class="text-center">
                                {{ $t("daylogs.reg_regular_working_time") }}
                            </h3>
                        </div>
                        <div class="col-4 text-center">
                            <le-clock v-model="day.time_start" />
                            <div class="label">
                                {{ $t("daylogs.start_time") }}
                            </div>
                            <div class="small text-muted">
                                {{ $t("daylogs.time_of_day") }}
                            </div>
                            <v-form-error name="time_start" :errors="errors" />
                        </div>
                        <div class="col-4 ">
                            <v-triple-time
                                style=" width: 210px; margin-left: auto; margin-right: auto;"
                                v-model="day.pause_time"
                                :enable-controls="true"
                                :interval="300"
                            />
                            <div class="label">
                                {{ $t("daylogs.pause_length") }}
                            </div>
                            <div class="text-center small text-muted">
                                {{ $t("daylogs.duration_in_min") }}
                            </div>
                        </div>
                        <div class="col-4 text-center">
                            <le-clock v-model="day.time_stop" />
                            <div class="label">
                                {{ $t("daylogs.stop_time") }}
                            </div>
                            <div class="small text-muted">
                                {{ $t("daylogs.time_of_day") }}
                            </div>
                            <v-form-error name="time_stop" :errors="errors" />
                        </div>
                    </template>
                    <div class="col-12" v-else>
                        <div class="pt-3 text-center">
                            {{ $t("daylogs.reset_and_enable_reg") }}
                            <div class="mt-1">
                                <base-button
                                    type="primary"
                                    outline
                                    size="sm"
                                    @click="enableDayReg"
                                    >{{
                                        $t(
                                            "daylogs.btn_enable_reset_start_stop_reg_again"
                                        )
                                    }}</base-button
                                >
                            </div>
                        </div>
                    </div>
                </div>

                <div class="status" v-if="enableReg">
                    <div v-if="day.status === 0">
                        <i class="far fa-empty-set"></i>
                        {{ $t("daylogs.status") }}:
                        {{ $t("daylogs.status_empty") }}
                    </div>
                    <div v-else-if="day.status === 1">
                        <i class="far fa-lock-open"></i>
                        {{ $t("daylogs.status") }}:
                        {{ $t("daylogs.status_open") }}
                    </div>
                    <div v-else-if="day.status === 2">
                        <i class="far fa-lock"></i> {{ $t("daylogs.status") }}:
                        {{ $t("daylogs.status_closed") }}
                    </div>
                    <div class="mt-1">
                        <base-button
                            size="sm"
                            type="warning"
                            outline
                            @click="disableDayReg"
                            >{{
                                $t("daylogs.btn_remove_time_reg")
                            }}</base-button
                        >
                    </div>
                </div>

                <hr class="mt-4" />

                <!-- Register sickness, holidays & co . -->
                <div class="row text-center">
                    <div class="col">
                        <h3>
                            <i class="far fa-fw fa-head-side-cough"></i>
                            {{ $t("daylogs.reg_sickess") }}
                        </h3>
                        <v-triple-time
                            style=" width: 210px; margin-left: auto; margin-right: auto;"
                            v-model="day.absence_sick_time"
                            :disabled="!enableSick"
                            :enable-controls="true"
                            :snap-to="60"
                            :interval="300"
                        />
                        <div class="mt-2">
                            <base-button
                                :disabled="!enableSick"
                                size="sm"
                                outline
                                type="danger"
                                @click="resetEntry('sick')"
                                ><i class="far fa-trash"></i
                            ></base-button>
                            <base-button
                                :disabled="!enableSick"
                                size="sm"
                                outline
                                type="primary"
                                @click="markRemDay('sick')"
                                >{{
                                    $t("daylogs.btn_use_remaining_time")
                                }}</base-button
                            >
                            <base-button
                                size="sm"
                                outline
                                type="primary"
                                @click="markWholeDay('sick')"
                                >{{
                                    $t("daylogs.btn_reg_full_sick_day")
                                }}</base-button
                            >
                        </div>
                    </div>
                    <div class="col">
                        <h3>
                            <i class="far fa-user-slash"></i>
                            {{ $t("daylogs.reg_other") }}
                        </h3>
                        <v-triple-time
                            style=" width: 210px; margin-left: auto; margin-right: auto;"
                            v-model="day.absence_others"
                            :enable-controls="true"
                            :disabled="!enableOthers"
                            :snap-to="60"
                            :interval="300"
                        />
                        <div class="mt-2">
                            <base-button
                                :disabled="!enableOthers"
                                size="sm"
                                outline
                                type="danger"
                                @click="resetEntry('other')"
                                ><i class="far fa-trash"></i
                            ></base-button>
                            <base-button
                                :disabled="!enableOthers"
                                size="sm"
                                outline
                                type="primary"
                                @click="markRemDay('other')"
                                >{{
                                    $t("daylogs.btn_use_remaining_time")
                                }}</base-button
                            >
                            <base-button
                                size="sm"
                                outline
                                type="primary"
                                @click="markWholeDay('other')"
                                >{{
                                    $t("daylogs.btn_reg_full_sick_day")
                                }}</base-button
                            >
                        </div>
                    </div>
                    <div class="col">
                        <h3>
                            <i class="far fa-tree-palm"></i>
                            {{ $t("daylogs.reg_holiday") }}
                        </h3>
                        <v-triple-time
                            style=" width: 210px; margin-left: auto; margin-right: auto;"
                            v-model="day.absence_holiday_time"
                            :disabled="!enableHoli"
                            :enable-controls="true"
                            :snap-to="60"
                            :interval="300"
                        />
                        <div class="mt-2">
                            <base-button
                                :disabled="!enableHoli"
                                size="sm"
                                outline
                                type="danger"
                                @click="resetEntry('holi')"
                                ><i class="far fa-trash"></i
                            ></base-button>
                            <base-button
                                :disabled="!enableHoli"
                                size="sm"
                                outline
                                type="primary"
                                @click="markRemDay('holi')"
                                >{{
                                    $t("daylogs.btn_use_remaining_time")
                                }}</base-button
                            >
                            <base-button
                                size="sm"
                                outline
                                type="primary"
                                @click="markWholeDay('holi')"
                                >{{
                                    $t("daylogs.btn_reg_full_sick_day")
                                }}</base-button
                            >
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="mt-3">
                            <input
                                type="checkbox"
                                class="ml-2 mr-2"
                                v-model="day.off_in_lieu"
                                :true-value="1"
                                :false-value="0"
                            />
                            {{
                                $t(
                                    "daylogs.i_am_using_lieu_off_work_on_this_day"
                                )
                            }}
                        </div>
                    </div>
                    <div class="col-12" v-if="total_absence > day.goal_time">
                        <div class="alert alert-danger mt-4">
                            <i class="far fa-exclamation-triangle"></i>
                            {{
                                $t(
                                    "daylogs.alert_canno_save_because_absence_more_than_goal"
                                )
                            }}
                        </div>
                    </div>
                </div>

                <hr class="mt-4" />

                <div class="d-flex text-right mt-5">
                    <div class="">
                        <base-button
                            size="lg"
                            type="default"
                            @click="navigateOverview"
                            outline
                            ><i class="far fa-calendar-alt"></i>
                            {{ $t("daylogs.go_to_overview") }}</base-button
                        >
                        <base-button
                            v-if="day.id !== null"
                            size="lg"
                            type="danger"
                            @click="deleteEntry"
                            outline
                            ><i class="far fa-trash"></i>
                            {{ $t("daylogs.delete") }}</base-button
                        >
                    </div>

                    <div class="ml-auto">
                        <base-button
                            size="lg"
                            type="white"
                            @click="$emit('close')"
                            >{{ $t("daylogs.cancel") }}</base-button
                        >
                        <base-button
                            size="lg"
                            :type="canSave ? 'primary' : 'danger'"
                            :outline="canSave ? false : true"
                            @click="saveForm"
                            :disabled="!canSave"
                            :loading="saving"
                        >
                            <template v-if="canSave">{{
                                $t("daylogs.save")
                            }}</template>
                            <template v-else>{{
                                $t("daylogs.btn_err_cannot_save")
                            }}</template></base-button
                        >
                    </div>
                </div>
                <pre v-if="false">{{ day }}</pre>
            </template>
        </template>
    </modal>
</template>

<style lang="scss">
.daylog-form {
    .label {
        text-align: center;
        margin-top: 10px;
        font-size: 14px;
    }

    .status {
        text-align: center;
        margin-top: 30px;
        font-size: 14px;
        color: $info;
    }
}
</style>
